import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import {
  fetchRecipientsError,
  fetchRecipientsSuccess,
  updateDataError,
  updateDataSuccess,
} from './actions'
import {
  CHANGE_RECIPIENTS_SEARCH_FILTER,
  DATA_UPDATE_ASYNC,
  RECIPIENTS_REQUEST_ASYNC,
} from './constants'

const updateDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DATA_UPDATE_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .updateAnnouncementLocale(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data
      )
      .mergeMap((response) =>
        Observable.of(updateDataSuccess(response), addToast({ message: 'Updated!' }))
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(updateDataError, error),
          addToast({
            message: error.response?.message,
            type: 'error',
            id: 'End_User_Notification_Editor_Update_Error',
          })
        )
      )
      .takeUntil(action$.ofType(DATA_UPDATE_ASYNC.CANCEL))
  )

const fetchRecipientsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(RECIPIENTS_REQUEST_ASYNC.INITIATE, CHANGE_RECIPIENTS_SEARCH_FILTER).mergeMap(() =>
    api.settings
      .fetchAnnouncementsParticipants(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().partnerOptions.selectedCompany?.value || store.getState().app.data.id,
        {
          searchFilter: store.getState().settings.notifications.editor.recipientsSearchFilter,
        }
      )
      .map((response) => fetchRecipientsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchRecipientsError, error)))
      .takeUntil(action$.ofType(RECIPIENTS_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(updateDataEpic, fetchRecipientsEpic)
